export default "__VITE_ASSET__BCvtueDW__"